import { createAction } from '@reduxjs/toolkit';
import { validatePayload } from '../../../utils/validate-payload.js';
import { parametersDefinition } from '../parameters/parameters-schema.js';
export const restoreProductListingParameters = createAction('commerce/productListingParameters/restore', (payload) => validatePayload(payload, parametersDefinition));
